import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {SelectBox} from "devextreme-react/select-box";
import {useState} from "react";

export function LaminatePopupControl() {
    const adapterContext = useEEToolAdapterContext();
    const [optionsSource, setOptionsSource] = useState<{ Id: number, Description: string }[]>([]);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'OK',
        onClick: () => {
            adapterContext.handleLaminate(adapterContext.laminateProduct ?? 0);
        },
    };

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => adapterContext.hidePopupLaminate()
    };

    if (!adapterContext.popupLaminateVisible)
        return <></>;

    return (
        <>
            <Popup
                title={adapterContext.popupLaminateTitle}
                visible={adapterContext.popupLaminateVisible}
                width={adapterContext.popupSize.width}
                height={adapterContext.popupSize.height}
                hideOnOutsideClick={true}
                showCloseButton={true}
                onHidden={() => adapterContext.hidePopupLaminate()}
            >
                <Position at={'left top'} my={'left top'} offset={{
                    x: adapterContext.popupLocation.left,
                    y: adapterContext.popupLocation.top
                }}></Position>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    disabled={(adapterContext.laminateProduct ?? 0) === 0}
                    options={getOKButtonOptions}
                >
                </ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <SelectBox
                            label={adapterContext.popupLaminateTitle}
                            labelMode={'outside'}
                            width={'100%'}
                            dataSource={adapterContext.laminateProducts}
                            displayExpr="Description"
                            valueExpr="Id"
                            value={adapterContext.laminateProduct}
                            onValueChanged={(e) => adapterContext.setLaminateProduct(e.value)}
                            searchEnabled={false}
                        />
                    </div>
                </div>
            </Popup>
        </>
    );
}
